import { HiCash, HiDeviceMobile, HiCreditCard } from 'react-icons/hi';

import Cash from '../services/components/payment-methods/Cash';
import EPayment from '../services/components/payment-methods/EPayment';
import Card from '../services/components/payment-methods/Card';
import PrintReceipt from '../services/components/payment-methods/PrintReceipt';
import Order from './order';
// import Settings from './settings';
import RecentTransactions from './recent-transactions';

export const ROUTES = [
  {
    key: 'order',
    name: 'Order',
    icon: null,
    component: Order,
    path: '/order',
    to: '/order',
    module_permission: true,
  },
  {
    key: 'recent-transactions',
    name: 'Recent Transactions',
    icon: null,
    component: RecentTransactions,
    path: '/recent-transactions',
    to: '/recent-transactions',
    module_permission: true,
  },
  // {
  //   key: 'setting',
  //   name: 'Settings',
  //   icon: null,
  //   component: Settings,
  //   path: '/setting',
  //   to: '/setting',
  //   module_permission: true,
  // },
];

export const PAYMENT_ROUTES = [
  {
    key: 'cash',
    name: 'cash',
    icon: HiCash,
    component: Cash,
    path: '/cash',
    to: '/cash',
    module_permission: true,
  },
  {
    key: 'epayment',
    name: 'epayment',
    icon: HiDeviceMobile,
    component: EPayment,
    path: '/epayment',
    to: '/epayment',
    module_permission: false,
  },
  {
    key: 'card',
    name: 'card',
    icon: HiCreditCard,
    component: Card,
    path: '/card',
    to: '/card',
    module_permission: false,
  },
  {
    key: 'receipt',
    name: 'Receipt',
    icon: null,
    component: PrintReceipt,
    path: '/receipt',
    to: '/receipt',
    module_permission: true,
  },
];

export const PAYMENT_OPTS_ROUTES = PAYMENT_ROUTES?.filter(
  (item) => item?.key !== 'receipt'
);
